(function ($) {
  'use strict';
 
  function openCartDrawer() {
    var $cartContainer = $('#header .cart-container');
    if ($cartContainer.length) {
      $cartContainer.addClass('active_link');
    }
    if ($(window).width() <= 768) {
      $('html, body').animate({ scrollTop: 0 }, 300);
    }
  }
 
  function updateCart() {
    if (typeof refreshCart === 'function') {
      try {
        refreshCart();
        return;
      } catch (e) {}
    }
 
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        $('.cart-count, .cart_count, [data-cart-count], #header .cart-container .count').text(count);
      })
      .catch(function () {});
  }
 
  function setButtonState($btn, state) {
    if (!$btn.data('original-html')) {
      $btn.data('original-html', $btn.html());
    }
    var originalHtml = $btn.data('original-html');
 
    if (state === 'loading') {
      $btn.prop('disabled', true).html('<span>Adding...</span>');
    } else if (state === 'success') {
      $btn.prop('disabled', true).html('<span>Added!</span>');
      setTimeout(function () {
        $btn.prop('disabled', false).html(originalHtml);
      }, 2000);
    } else if (state === 'error') {
      $btn.prop('disabled', true).html('<span>Error — try again</span>');
      setTimeout(function () {
        $btn.prop('disabled', false).html(originalHtml);
      }, 2500);
    }
  }
 
  $(document).on('click', '.trending-products-atc-button', function (e) {
    e.preventDefault();
 
    var $btn = $(this);
    var variantId = $btn.data('variant-id');
 
    if (!variantId) {
      console.error('Trending ATC Fix: no variant ID found on button.');
      return;
    }
 
    var $wrapper = $btn.closest('.custom-product-card-atc-wrapper');
    var qty = 1;
    if ($wrapper.length) {
      var inputVal = parseInt($wrapper.find('.custom-product-card-quantity__input').val(), 10);
      if (!isNaN(inputVal) && inputVal > 0) {
        qty = inputVal;
      }
    }
 
    setButtonState($btn, 'loading');
 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: qty,
        id: variantId
      },
      dataType: 'json',
      success: function () {
        setButtonState($btn, 'success');
        updateCart();
        openCartDrawer();
      },
      error: function (xhr) {
        var response;
        try {
          response = JSON.parse(xhr.responseText);
        } catch (err) {
          response = {};
        }
        console.error('Trending ATC Fix: /cart/add.js failed.', response.description || xhr.statusText);
        setButtonState($btn, 'error');
      }
    });
  });
 
  $(document).on('click', '.custom-product-card-quantity__button--minus', function () {
    var $input = $(this).closest('.custom-product-card-quantity').find('.custom-product-card-quantity__input');
    var current = parseInt($input.val(), 10) || 1;
    if (current > 1) {
      $input.val(current - 1);
    }
  });
 
  $(document).on('click', '.custom-product-card-quantity__button--plus', function () {
    var $input = $(this).closest('.custom-product-card-quantity').find('.custom-product-card-quantity__input');
    var current = parseInt($input.val(), 10) || 1;
    $input.val(current + 1);
  });
 
})(jQuery);
 